module.exports = __webpack_public_path__ + "img/m-hom.9329fd1d.webp";